import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-servicii-pentru-pacienti',
  templateUrl: './servicii-pentru-pacienti.component.html',
  styleUrls: ['./servicii-pentru-pacienti.component.scss']
})
export class ServiciiPentruPacientiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
